import {
    NestedEditModel,
    RateRuleEditModel,
    RateRuleLookupModel,
    RateRuleSelectListItem
} from '@/services/api/nswag/stapiclient_generated';

function addRangeFromLookup(resultArray: number[] | null | undefined, lookupArray: RateRuleSelectListItem[] | null | undefined){
    if(!resultArray || !lookupArray){
        return;
    }

    resultArray.push.apply(resultArray, lookupArray
        .filter(x=>x.disabledChildSelected)
        .filter(x=>resultArray.indexOf(x.id!)<0).map(x=>x.id!));
}

//Child Rule filtert auf ungefiltertes Parent Element
//Wenn dann Parent "geöffnet" wird, müssen die items gesetzt werden
export module RateRuleEditValidation{
    export function SetItemsParentNotSelected(item: RateRuleEditModel, lookups: RateRuleLookupModel){
        addRangeFromLookup(item.appUserIds, lookups.appUsers)
        addRangeFromLookup(item.projectTaskIds, lookups.projectTasks)

        if(item.customerIds && lookups.customerProjects){
            lookups.customerProjects.filter(x=>x.disabledChildSelected).forEach(x=>{
                if(item.customerIds?.some(y=>y.id == x.id)){
                    item.customerIds.find(x=>x.id)!.allSelected = true;
                }else{
                    const newItem: NestedEditModel = NestedEditModel.fromJS({id: x.id, allSelected: true, nestedIds: []});
                    item.customerIds!.push(newItem);
                }
            });

            lookups.customerProjects.filter(x=>!x.disabledChildSelected).forEach(x=>{
                if(x.childItems?.some(z=>z.disabledChildSelected)) {
                    let customer = item.customerIds?.find(y=>y.id == x.id);

                    if(!customer){
                        item.customerIds!.push(NestedEditModel.fromJS({id: x.id, allSelected: false, nestedIds: []}));
                        customer = item.customerIds!.find(y=>y.id == x.id)!;
                    }

                    addRangeFromLookup(customer.nestedIds?.map(x=>x.id!) ?? [], x.childItems);
                }
            });
        }
    }
}

